import { type UseQueryResult, useQuery } from 'react-query';
import {
  ParticipantCashTransferServiceService,
} from '@wealthlane/api-services/wealthlane-award-settlement-service';
import { Wealthlane_AwardSettlementService_Dtos_ParticipantCashBalance_CashTransferDetailDto } from '@wealthlane/api-services/wealthlane-award-settlement-service';

const useGetCashTransferDetail = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  cashTransferRequestCode?: string | null
): UseQueryResult<
  // eslint-disable-next-line camelcase
  | Wealthlane_AwardSettlementService_Dtos_ParticipantCashBalance_CashTransferDetailDto
  | undefined,
  unknown
> => {
  return useQuery(
    ['getCashTransferDetail', cashTransferRequestCode],
    async () => {
      return await handleRequest(
        ParticipantCashTransferServiceService.getApiAwardSettlementApiAppParticipantCashTransferServiceCashTransferDetail(
          cashTransferRequestCode ?? undefined
        )
      );
    },
    {
      enabled: !!cashTransferRequestCode,
    }
  );
};

export default useGetCashTransferDetail;
